module.exports = __webpack_public_path__ + "img/horizontal_4_2_8003.8322cc68.png";